<template>
  <div>
    <transition-group name="player-transition" tag="div" class="street-players">

      <div v-for="(player, i) in players" :key="'stp' + i" class="d-flex flex-column align-center player-item" :class="{
        'exit-left': removing && i > 2 && !allPlayers && playerID == i,
        'exit-right': removing && i <= 2 && !allPlayers && playerID == i,
        'enter-left': !removing && i > 2 && !allPlayers && playerID == i,
        'enter-right': !removing && i <= 2 && !allPlayers && playerID == i,
        'appear': !removing && allPlayers,
        'disappear': removing && allPlayers,
      }">
        <div v-if="player == 'NONE'" style="width: 100px"></div>
        <div v-else id="avatar" :class="i > 2 ? 'flip-horizontal' : ''" :key="player.mochiId" @click="
          showPlayerInfoDialog = true;
        selectedPlayer = player;
        ">
          <AbstractAvatar :key="player.mochiId" :avatar="player.avatar" :height="100" :width="100"
            class="animated-avatar"></AbstractAvatar>
        </div>

        <div class="player-name">
          {{ player.mochiId }}
        </div>
      </div>

    </transition-group>
    <PlayerInfoDialog :key="selectedPlayer.mochiId" v-if="selectedPlayer" :showDialog="showPlayerInfoDialog"
      :callbackClose="() => {
        showPlayerInfoDialog = false;
      }
        " :data="selectedPlayer" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import AvatarSkeleton from "@/components/skeleton/Avatar";
export default {
  components: {
    AbstractAvatar: () => ({
      component: import(
        /* webpackChunkName: "component-abstract-avatar-testing" */ "@/components/avatar/AbstractAvatar"
      ),
      loading: AvatarSkeleton,
      delay: 200,
    }),

    PlayerInfoDialog: () =>
      import(
        /* webpackChunkName: "component-player-info-dialog" */ "@/components/PlayerInfoDialog.vue"
      ),
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
    showPlayerInfoDialog: false,
    selectedPlayer: null,
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    players: [],
    removing: false,
    allPlayers: true,
    playerID: null,
    timeoutToRemove: null,
    timeoutToEnter: null
  }),
  async created() {
    await this.loadPlayers();
  },
  mounted() {
    //
  },
  beforeDestroy() {
    // Clear all timeouts when component is destroyed
    this.clearAllTimeouts();
  },
  methods: {
    clearAllTimeouts() {
      if (this.timeoutToRemove) {
        clearTimeout(this.timeoutToRemove);
        this.timeoutToRemove = null;
      }
      if (this.timeoutToEnter) {
        clearTimeout(this.timeoutToEnter);
        this.timeoutToEnter = null;
      }
    },
    removePlayers() {
      if (this.timeoutToRemove) {
        clearTimeout(this.timeoutToRemove);
        this.timeoutToRemove = null;
      }
      if (this.timeoutToEnter) {
        clearTimeout(this.timeoutToEnter);
        this.timeoutToEnter = null;
      }
      this.allPlayers = true
      this.removing = true;
      // Allow time for animation to play before clearing
      setTimeout(async () => {
        this.players = [];
        this.removing = false;
        await this.loadPlayers();
      }, 500); // match your CSS animation duration
    },
    async loadPlayers() {
      const showChance = Math.random();
      if (showChance > 0.9) {
        this.players = [];
        return;
      }
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/strangers/random";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.players = this.fillPlayersRandomly(resp);
        this.leaveAndEnterPlayer()
      };
      this.api.params = {
        count: showChance > 0.8 ? 6 : showChance > 0.7 ? 5 : showChance > 0.5 ? 4 : showChance > 0.4 ? 3 : showChance > 0.2 ? 2 : 1,
        currentStrangerMochiIds: []
      };
      await this.$api.fetch(this.api);
    },

    async loadOnePlayer(index) {
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/strangers/random";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        if (resp.length > 0)
          this.players[index] = resp[0]

        this.removing = false;
        this.allPlayers = false
        this.playerID = index
        this.leaveAndEnterPlayer()
      };
      this.api.params = {
        count: 1,
        currentStrangerMochiIds: this.players.filter(player => player !== "NONE").map(player => player.mochiId)
      };
      await this.$api.fetch(this.api);
    },

    leaveAndEnterPlayer() {
      this.timeoutToRemove = setTimeout(() => {
        if (this.timeoutToRemove) {
          clearTimeout(this.timeoutToRemove);
          this.timeoutToRemove = null;
        }
        const randomPlayer = Math.floor(Math.random() * 6);
        this.removing = true;
        this.allPlayers = false
        this.playerID = randomPlayer
        this.timeoutToEnter = setTimeout(() => {
          if (this.timeoutToEnter) {
            clearTimeout(this.timeoutToEnter);
            this.timeoutToEnter = null;
          }
          this.players[randomPlayer] = "NONE"
          this.loadOnePlayer(randomPlayer)
        }, Math.random() * (5000 - 800) + 800);
      }, Math.random() * (5000 - 2000) + 2000);
    },

    fillPlayersRandomly(resp) {
      const filled = [...resp]; // Copy the players
      while (filled.length < 6) {
        filled.push("NONE"); // Fill with "NONE" if less than 4
      }

      // Shuffle the array to randomize positions
      for (let i = filled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [filled[i], filled[j]] = [filled[j], filled[i]];
      }

      return filled;
    }
  },
};
</script>

<style scoped>
.animated-avatar {
  animation: idle 2s infinite alternate ease-in-out;
  transform-origin: center calc(100% - 5px);
}

@keyframes idle {
  0% {
    transform: scale(1, 1);
    /* Original size */
  }

  100% {
    transform: scale(1, 1.05);
    /* Slightly stretched */
  }
}

.flip-horizontal {
  transform: scaleX(-1);
}

.street-players {
  display: flex;
  justify-content: space-between;
  width: 1300px;
  overflow: hidden;
  position: absolute;
  bottom: 140px;
  left: 50%;
  /* Center point of the parent */
  transform: translateX(-50%);
  /* Shift left by half of its own width */
  z-index: 4;
  pointer-events: none;

}

.player-name {
  /* max-width: 100px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  font-size: 10px;
}


.player-item {
  transition: transform 0.5s ease, opacity 0.5s ease;
  cursor: pointer;
  pointer-events: all;
}

/* EXIT animations */
.exit-left {
  animation: exitLeft 0.5s forwards;
}

.exit-right {
  animation: exitRight 0.5s forwards;
}

@keyframes exitLeft {
  to {
    transform: translateX(200px);
    opacity: 0;
  }
}

@keyframes exitRight {
  to {
    transform: translateX(-200px);
    opacity: 0;
  }
}

/* ENTER animations */
.enter-left {
  animation: enterLeft 0.5s ease-out;
}

.enter-right {
  animation: enterRight 0.5s ease-out;
}

@keyframes enterLeft {
  from {
    transform: translateX(200px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes enterRight {
  from {
    transform: translateX(-200px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.appear {
  animation: appearing 0.2s ease-in forwards;
}

.disappear {
  animation: disappearing 0.2s ease-out forwards;
}

@keyframes appearing {
  0% {
    opacity: 0;
  }

  /* 20% {
    opacity: 1;
  }

  40% {
    opacity: 0;
  }

  60% {
    opacity: 1;
  }

  80% {
    opacity: 0;
  } */

  100% {
    opacity: 1;
  }
}

@keyframes disappearing {
  0% {
    opacity: 1;
  }

  /* 20% {
    opacity: 0;
  }

  40% {
    opacity: 1;
  }

  60% {
    opacity: 0;
  }

  80% {
    opacity: 1;
  } */

  100% {
    opacity: 0;
  }
}
</style>